/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAutotaskTicketFields200ResponseStatusesInner } from './GetAutotaskTicketFields200ResponseStatusesInner';
import {
    GetAutotaskTicketFields200ResponseStatusesInnerFromJSON,
    GetAutotaskTicketFields200ResponseStatusesInnerFromJSONTyped,
    GetAutotaskTicketFields200ResponseStatusesInnerToJSON,
    GetAutotaskTicketFields200ResponseStatusesInnerToJSONTyped,
} from './GetAutotaskTicketFields200ResponseStatusesInner';

/**
 * 
 * @export
 * @interface GetAutotaskTicketFields200Response
 */
export interface GetAutotaskTicketFields200Response {
    /**
     * 
     */
    statuses: Array<GetAutotaskTicketFields200ResponseStatusesInner>;
    /**
     * 
     */
    priorities: Array<GetAutotaskTicketFields200ResponseStatusesInner>;
    /**
     * 
     */
    queues: Array<GetAutotaskTicketFields200ResponseStatusesInner>;
    /**
     * 
     */
    ticketTypes: Array<GetAutotaskTicketFields200ResponseStatusesInner>;
}

/**
 * Check if a given object implements the GetAutotaskTicketFields200Response interface.
 */
export function instanceOfGetAutotaskTicketFields200Response(value: object): value is GetAutotaskTicketFields200Response {
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    if (!('priorities' in value) || value['priorities'] === undefined) return false;
    if (!('queues' in value) || value['queues'] === undefined) return false;
    if (!('ticketTypes' in value) || value['ticketTypes'] === undefined) return false;
    return true;
}

export function GetAutotaskTicketFields200ResponseFromJSON(json: any): GetAutotaskTicketFields200Response {
    return GetAutotaskTicketFields200ResponseFromJSONTyped(json, false);
}

export function GetAutotaskTicketFields200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutotaskTicketFields200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'statuses': ((json['statuses'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerFromJSON)),
        'priorities': ((json['priorities'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerFromJSON)),
        'queues': ((json['queues'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerFromJSON)),
        'ticketTypes': ((json['ticketTypes'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerFromJSON)),
    };
}

export function GetAutotaskTicketFields200ResponseToJSON(json: any): GetAutotaskTicketFields200Response {
    return GetAutotaskTicketFields200ResponseToJSONTyped(json, false);
}

export function GetAutotaskTicketFields200ResponseToJSONTyped(value?: GetAutotaskTicketFields200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statuses': ((value['statuses'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerToJSON)),
        'priorities': ((value['priorities'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerToJSON)),
        'queues': ((value['queues'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerToJSON)),
        'ticketTypes': ((value['ticketTypes'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerToJSON)),
    };
}

